module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iYGBA"))).then(() => parcelRequire('1iHdE'));